import { InputBase, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  '&.chatyme-disabled-search:hover': {
    borderColor: theme.palette.divider
  },
  '&.chatyme-disabled-search:focus-within': {
    borderColor: theme.palette.divider
  },
  '&:hover': {
    borderColor: alpha(theme.palette.info.main, 0.8)
  },
  '&:focus-within': {
    borderColor: alpha(theme.palette.info.main, 0.8)
  },
  marginRight: theme.spacing(2),
  width: '100%',
  display: 'flex',
  alignItems: 'center'
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%'
  }
}));
